import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import { addStudentScholarshipOperation } from '../operations/add-student-scholarship-operation';
import { SelectScholarshipFunderDialog } from './select-scholarship-funder-dialog';
import { ScholarshipFundersEntities } from '../../../../../../api/types/settings/scholarship-funders';

interface AddStudentScholarshipDialogProps {
  visible: boolean;
  userId: number;
  onHide: () => void;
}

export const AddStudentScholarshipDialog: React.FC<
  AddStudentScholarshipDialogProps
> = ({ visible, userId, onHide }) => {
  const [scholarshipSum, setScholarshipSum] = useState<number | null>(null);
  const [funderId, setFunderId] = useState<number | null>(null);
  const [funderName, setFunderName] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [showFunderDialog, setShowFunderDialog] = useState(false);

  const handleClose = () => {
    setScholarshipSum(null);
    setFunderId(null);
    setFunderName(null);
    onHide();
  };

  const handleFunderSelect = (funder: ScholarshipFundersEntities) => {
    setFunderId(funder.id);
    setFunderName(funder.funderName);
    setShowFunderDialog(false);
  };

  const handleApprove = async () => {
    if (scholarshipSum === null || scholarshipSum <= 0 || !funderId) {
      return;
    }

    await addStudentScholarshipOperation(
      userId,
      scholarshipSum,
      funderId,
      setLoading,
      handleClose,
    );
  };

  const isValid =
    scholarshipSum !== null && scholarshipSum > 0 && funderId !== null;

  return (
    <>
      <Dialog
        header="הוספת מלגה חדשה"
        visible={visible}
        onHide={handleClose}
        style={{ width: '420px', direction: 'rtl' }}
        modal
        closable={!loading}
        footer={
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '0.5rem',
            }}
          >
            <Button
              label="ביטול"
              icon="pi pi-times"
              severity="secondary"
              text
              onClick={handleClose}
              disabled={loading}
            />
            <Button
              label={loading ? 'שומר...' : 'אישור'}
              icon={loading ? 'pi pi-spin pi-spinner' : 'pi pi-check'}
              onClick={handleApprove}
              disabled={!isValid || loading}
              loading={loading}
            />
          </div>
        }
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <div className="p-field">
            <label
              htmlFor="scholarshipSum"
              style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: 600,
                color: '#374151',
              }}
            >
              סכום מלגה *
            </label>
            <InputNumber
              id="scholarshipSum"
              value={scholarshipSum}
              onValueChange={(e) => setScholarshipSum(e.value)}
              mode="currency"
              currency="ILS"
              locale="he-IL"
              min={0}
              maxFractionDigits={2}
              style={{ width: '100%', direction: 'ltr' }}
              inputStyle={{ direction: 'rtl', textAlign: 'right' }}
              disabled={loading}
              placeholder="הזן סכום מלגה"
            />
          </div>

          <div className="p-field">
            <label
              htmlFor="scholarshipFunder"
              style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: 600,
                color: '#374151',
              }}
            >
              גורם מממן *
            </label>
            <Button
              id="scholarshipFunder"
              label={funderName || 'בחר גורם מממן'}
              icon="pi pi-search"
              onClick={() => setShowFunderDialog(true)}
              disabled={loading}
              style={{ width: '100%', justifyContent: 'flex-start' }}
              severity={funderId ? undefined : 'secondary'}
              outlined={!funderId}
            />
          </div>
        </div>
      </Dialog>
      <SelectScholarshipFunderDialog
        visible={showFunderDialog}
        onHide={() => setShowFunderDialog(false)}
        onSelect={handleFunderSelect}
      />
    </>
  );
};
